import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
//services
import { TabService } from './tab.service';
import { TabComponent } from './tab.component';
import { AppCodeGroup, ControlsParams } from '../../shared';


@NgModule({
    declarations: [
        TabComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        RouterModule,
        TabComponent
    ],
    providers: [
        TabService
    ]
})
export class TabModule {
}
